import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, RepeatIcon, ListChecksIcon, PackageIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const TABS = [{
  to: '/',
  label: 'Home',
  icon: HomeIcon,
  end: true
}, {
  to: '/habits',
  label: 'Habits',
  icon: RepeatIcon,
  end: false
}, {
  to: '/tasks',
  label: 'Tasks',
  icon: ListChecksIcon,
  end: false
}, {
  to: '/borrowed',
  label: 'Borrowed',
  icon: PackageIcon,
  end: false
}];
export function BottomNav() {
  return <nav className="flex h-[72px] shrink-0 items-stretch border-t border-slate-200 bg-white px-2 pb-1" aria-label="Primary" data-id="element-95" data-mp="3mjgew156ljjz">
      {TABS.map(tab => <NavLink key={tab.to} to={tab.to} end={tab.end} className="relative flex flex-1 flex-col items-center justify-center gap-1" data-id="element-96" data-mp="3rlffj39je2d8">
          {({
        isActive
      }) => <>
              {isActive && <motion.div layoutId="bottom-nav-indicator" className="absolute top-1.5 h-8 w-14 rounded-full bg-teal-50" transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-97" data-mp="1bropgey2q0lh" />}
              <tab.icon className={`relative z-10 h-5 w-5 ${isActive ? 'text-teal-700' : 'text-slate-400'}`} strokeWidth={isActive ? 2.25 : 2} data-id="element-98" data-mp="1lwm6vr4lmuf3" />
              <span className={`relative z-10 text-[11px] font-medium ${isActive ? 'text-teal-700' : 'text-slate-400'}`} data-id="element-99" data-mp="1c0au7013k2k4">
                {tab.label}
              </span>
            </>}
        </NavLink>)}
    </nav>;
}